import { render } from "./MultiviewTile.vue?vue&type=template&id=704f5aca&scoped=true"
import script from "./MultiviewTile.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewTile.vue?vue&type=script&setup=true&lang=js"

import "./MultiviewTile.vue?vue&type=style&index=0&id=704f5aca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704f5aca"],['__file',"src/components/Multiview/MultiviewTile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "704f5aca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('704f5aca', __exports__)) {
    api.reload('704f5aca', __exports__)
  }
  
  module.hot.accept("./MultiviewTile.vue?vue&type=template&id=704f5aca&scoped=true", () => {
    api.rerender('704f5aca', render)
  })

}


export default __exports__